import { CTBase } from "@ctsolution/ct-base";
import { AddressBookTypeEnum } from "../interfaces/address-book-response";

export class AddressBookParameter extends CTBase<AddressBookParameter> {

    Oid: number | null = null;
    Name: string | null = null;
    Type: AddressBookTypeEnum | null = null;
    Shared: boolean | null = false;
    Enabled: boolean | null = false;
    CreateAt?: string | null;
    UpdateAt?: string | null;



    private constructor()
    private constructor(model?: AddressBookParameter);
    private constructor(model?: AddressBookParameter) {

        super();

        if (model) {

            this.getClass(model);

        }

    }

    public static create = (model?: AddressBookParameter): AddressBookParameter => new AddressBookParameter(model);

    setName(value: string | null) {

        this.Name = value;
        return this;

    }

    setOid(value : number | null){

        this.Oid = value;
        return this;

    }

    setType(value: AddressBookTypeEnum | null) {

        this.Type = value;
        return this;

    }

    setShared(value: boolean | null) {

        this.Shared = value;
        return this;

    }

    setEnabled(value: boolean | null) {

        this.Enabled = value;
        return this;

    }
}
